import axios from 'axios'
import {vm} from '@/main'

var baseUrl = process.env.VUE_APP_BASE_URL

const companies = {
    state: {
        companies: null,
        showAddCompanyForm: false,
        showCompanyModal: false
    },

    mutations: {
        setCompanies(state, companies){
            state.companies = companies
        },
        showAddCompanyForm(state){
            state.showAddCompanyForm = true
        },
        hideAddCompanyForm(state){
            state.showAddCompanyForm = false
        },
        showCompanyModal(state){
            state.showCompanyModal = true
        },
        hideCompanyModal(state){
            state.showCompanyModal = false
        }
    },

    actions: {
        getCompanies({ commit, rootState, dispatch, state }, page){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.get(baseUrl +'/api/search_companies?page='+page +'&q='+rootState.search)
                    .then(response => {
                        commit('setCompanies', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        createNewCompany({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/companies', {
                    name: formData.name,
                    address: formData.address,
                    reg_nr: formData.regNr,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getCompanies')
                        commit('hideAddCompanyForm')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },

        createNewCompanyFromModal({ commit, rootState, dispatch, state }, formData){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.post(baseUrl +'/api/companies', {
                    name: formData.name,
                    address: formData.address,
                    reg_nr: formData.regNr,
                })
                    .then(response => {
                        const token = response.data.access_token

                        dispatch('getCleaningInputData')
                        commit('hideCompanyModal')
                        vm.$Progress.finish()
                        dispatch('setSnackbar', {
                            color: 'green',
                            text: 'Uzņēmums pievienots'
                        })
                        resolve(response)
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                            location.reload();
                        }
                        reject(error)
                    })
            })
        },

        deleteCompany({commit, rootState, dispatch, state}, companyId){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token

            return new Promise((resolve, reject) => {

                axios.delete(baseUrl +'/api/companies/'+companyId)
                    .then(response => {
                        dispatch('getCompanies')
                        vm.$Progress.finish()
                        resolve(response)
                    })
                    .catch(error => {
                        console.log(error.response.status)
                        if (error.response.status === 401) {
                            dispatch('destroyToken')
                        }
                        reject(error)
                    })
            })
        },

        showAddCompanyForm({ commit }){
            commit('showAddCompanyForm')
        },
        hideAddCompanyForm({ commit }){
            commit('hideAddCompanyForm')
        },
        showCompanyModal({ commit }){
            commit('showCompanyModal')
        },
        hideCompanyModal({ commit }){
            commit('hideCompanyModal')
        },

    },
    getters: {
        companies(state){
            return state.companies
        },
        showAddCompanyForm(state){
            return state.showAddCompanyForm
        },
        showCompanyModal(state){
            return state.showCompanyModal
        },
    }
}

export default companies